import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { getApplicableL2MyDataModules } from 'Deer/components/navigation/secondary/ModuleSection';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import { InitiativeIntentLandingPage } from 'Deer/intent/initiative/InitiativeIntentLandingPage';
import { IntentDropdown } from 'Deer/intent/initiative/components/IntentDropdown';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView, useSelectedView } from 'reducers/viewsSlice';
import TabbedNavigationTitle from 'screens/Initiatives/Components/TabbedNavigationTitle';
import InitiativeAudit, { updatedThisYear } from 'screens/Initiatives/InitiativeAudit';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { ANALYTICS_FILTERS_KEYS } from 'constants/ProjectConstants';
import { getDateRangeFromLSBasedOnEndDateStartDate, setFiltersToLS } from 'constants/helper';
import { localStorageKeys } from 'constants/localStorageKeys';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const MyInitiatives = ({ cohort }: Props) => {
  const dispatch = useDispatch();
  const gridRef = useRef();

  const view = useSelectedView();
  const { moduleName } = useOrganisationSettings();

  // header timeline state

  const [dateRange, setDateRange] = useState(
    getDateRangeFromLSBasedOnEndDateStartDate(localStorageKeys?.rabbitInitiativeAnalyticsFilters) ?? updatedThisYear
  );

  const updateDateRange = useCallback(
    (date) => {
      setDateRange(date);
      setFiltersToLS(localStorageKeys.rabbitInitiativeAnalyticsFilters, ANALYTICS_FILTERS_KEYS.dateRange, date);
    },
    [setDateRange]
  );

  const applicableL2MyDataModules = getApplicableL2MyDataModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort]);

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <IntentDropdown
            initialDateRange={dateRange}
            breadcrumbs={{
              items: [
                {
                  label: 'Me',
                  to: applicableL2MyDataModules[0]?.value,
                },
              ],
              page: {
                label: 'Initiative',
                to: '',
              },
            }}
          />
        }
      >
        <InitiativeIntentLandingPage dateRange={dateRange} gridRef={gridRef} />
      </Layout>
    );
  }

  return (
    // @ts-expect-error : union too complex
    <Flex flexDir="column">
      <TabbedNavigationTitle cohortName={view?.name ?? ''} updateDateRange={updateDateRange} />
      {/* Remove if not needed */}
      {/* <PageTabbedNavigationV1 tabs={tabs} /> */}
      <InitiativeAudit dateRange={dateRange} />
    </Flex>
  );
};

export default MyInitiatives;
